import "date-fns";
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "components/Table/Table";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "components/CustomButtons/Button.js";
import Grid from '@material-ui/core/Grid';
import Chart from "components/Chart/ChartPermanencyRate";
import { getAllLockers } from "../../services/lockers/lockers";
import { getSlots } from "../../services/slots/slots";
import { getOrdersbyStatus } from "../../services/orders/orders";
import { getUser } from "../../services/users/users";
import { getAllLockersSelect } from "../../services/lockers/lockers";
import CircularProgress from "../Circular/Circular";
import Tooltip from '@material-ui/core/Tooltip';
import ExportCsv from "exportCsv.js";
import MomentUtils from "@date-io/date-fns";
import pt from "date-fns/locale/pt";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';

import '../Slots/style.css';

const useStyles = (theme) => ({
    iconView: {
        color: "gray !important",
    },
    root: {
        "& .MuiFormControl-root": {
            margin: theme.spacing(1),
            width: 200,
        },
    },
    dialog: {
        "& .MuiPaper-root": {
            margin: theme.spacing(1),
            width: 250,
            height: 200,
        },
    },
    green: {
        "& label.Mui-focused": {
            color: "green",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "green",
        },
    },
    red: {
        "& label.Mui-focused": {
            color: "red",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "red",
        },
    },
    semDados: {
        color: '#333333'
    }
});

class PermanencyRateGroup extends Component {
    constructor(props) {
        super(props);
        this.getOrders = this.getOrders.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.getDiff = this.getDiff.bind(this);
        this.addData = this.addData.bind(this);
        this.handleDateChangeInit = this.handleDateChangeInit.bind(this);
        this.handleDateChangeFinal = this.handleDateChangeFinal.bind(this);
        this.handleChangeLocker = this.handleChangeLocker.bind(this);
        this.handleChangeGroup = this.handleChangeGroup.bind(this);

        this.state = {
            selectedDate: new Date(),
            hours: [
                {
                    value: 1,
                    label: "1h",
                },
                {
                    value: 2,
                    label: "2h",
                },
                {
                    value: 3,
                    label: "3h",
                },
                {
                    value: 4,
                    label: "4h",
                }

            ],
            hour: 1,
            data: [],
            orders: [],
            circular: true,
            dataExport: [],
            selected: this.props.selected ? this.props.selected : 'Todos',
            months: [
                "Janeiro",
                "Fevereiro",
                "Março",
                "Abril",
                "Maio",
                "Junho",
                "Julho",
                "Agosto",
                "Setembro",
                "Outubro",
                "Novembro",
                "Dezembro"
            ],
            selectedDateInital: new Date().setDate(new Date().getDate() - 30),
            selectedDateFinal: new Date(),
            period: [0, 1, 12, 24, 36, 48, 60, 72],
            chartData: [],
            groups: [],
            lockers: [],
            group: null,
            lockerS: null,
            groupedLockers: {}
        };
    }

    componentDidMount() {
        this.getOrders();
    }

    handleDateChange(selectedDate) {
        this.setState({ selectedDate });
    }

    handleDateChangeInit(selectedDateInital) {
        this.setState({ selectedDateInital });
    }

    handleDateChangeFinal(selectedDateFinal) {
        this.setState({ selectedDateFinal });
    }

    handleChangeLocker(locker) {
        this.setState({ lockerS: locker.target.value });
    };

    handleChangeGroup(group) {
        this.setState({ group: group.target.value });
    }

    handleChange = (event) => {
        let hour = (event.target.value <= 1 || event.target.value > 72) ? 1 : event.target.value;
        this.setState({ hour });
    };

    handleExport = () => {
        const { dataExport } = this.state;
        ExportCsv(dataExport);
    };

    handleSearch = () => {
        let selectedDate = (this.state.selectedDate) ? new Date(this.state.selectedDate) : new Date();
        this.setState({ circular: true });
        this.getOrders(selectedDate.getFullYear(), (selectedDate.getMonth()));
    };

    getOrders = (year = (new Date()).getFullYear(), month = ((new Date()).getMonth())) => {
        const { selectedDateFinal, selectedDateInital, group, lockerS } = this.state;

        let orders = [];
        //let currentUser = JSON.parse(localStorage.getItem("user"));
        let groupedLockers = {};

        //getUser(currentUser.data.id, (us) => {
        getAllLockersSelect((us) => {
            us.listGrupos.push({
                value: null,
                label: "Todos",
            });

            us.listLockers.push({
                value: null,
                label: "Todos",
            });

            us.listGrupos.forEach(g => {
                groupedLockers[g.label] = [];
            });

            this.setState({ groups: us.listGrupos, lockers: us.listLockers });

            getAllLockers((lockers) => {

                if (lockers.length === 0) {
                    this.setState({ circular: false, data: [] });
                }

                let capacitySlots = 0

                lockers.forEach((locker, indexL) => {
                    let { id, group_lockers, name } = locker;

                    if (groupedLockers[group_lockers]) {
                        groupedLockers[group_lockers].push(`- ${name} \n\n`);
                    }

                    let availableLockers = null;
                    let availableGroups = null;

                    if (group || lockerS) {
                        availableLockers = lockerS === id;
                        availableGroups = group === group_lockers;
                    } else {
                        availableLockers = us.listLockers.findIndex(l => l.value == id);
                        availableGroups = us.listGrupos.findIndex(g => g.value == group_lockers);
                    }
                    if (availableLockers || availableGroups) {
                        getSlots(id, (slots) => {
                            capacitySlots += (slots.length) ? slots.length - 1 : 0;
                            getOrdersbyStatus(id, 'collected&status=courrier_collected', (order) => {
                                order = order.filter(o => o.collectedAt ? selectedDateInital <= new Date(o.collectedAt).getTime() && new Date(o.collectedAt).getTime() <= selectedDateFinal : false);

                                orders = orders.concat(order);
                                order = orders;

                            });
                        });
                    }

                    setTimeout(() => {
                        if (indexL === lockers.length - 1) {
                            this.addData(orders, capacitySlots, groupedLockers);
                        }
                    }, 500);
                });
            });
        });


    }

    addData = (order, capacitySlots, groupedLockers) => {
        const { period } = this.state;
        let data = [];
        let dataExport = [];
        let chartData = [];
        let orderDiff = [];
        let ordersCount = 0;

        if (order.length > 0) {

            order.forEach((o, index) => {

                orderDiff.push(this.getDiff(o));
            });

            for (let i = 1; i < period.length; i++) {

                if (i == 1) {
                    ordersCount = orderDiff.filter(o => o <= 1).length;
                } else if ((period.length - 1) == i) {
                    ordersCount = orderDiff.filter(o => o >= period[i]).length;
                } else {
                    ordersCount = orderDiff.filter(o => o <= period[i] && o > period[i - 1]).length;
                }

                let rate = Number(((ordersCount / order.length) * 100).toFixed(2));

                data.push([`${period[i]}`, `${rate}%`]);
                dataExport.push({ 'Permanência (horas)': `${period[i]}`, 'Taxa de permanência': `${rate}%` });
                chartData.push({ year: `${period[i]}`, max: rate });

            }

            this.setState({ circular: false, data, dataExport, orders: order, chartData, groupedLockers });
        } else {
            data.push(["Nenhuma encomenda retirada nesse período!"]);
            dataExport.push({ 'Permanência (horas)': `-`, 'Taxa de permanência': `-%` });

            this.setState({ circular: false, data, dataExport, orders: order, chartData });
        }
    }

    getDiff = (order) => {

        let diff = (Math.abs(new Date(order.collectedAt).getTime() - new Date(order.allocatedAt).getTime()) / 3600000).toFixed(2);
        diff = Number(String(diff).split('.')[0]);

        return diff;

    }

    render() {
        const { classes } = this.props;
        const { selectedDateInital, selectedDateFinal, chartData, data, circular, group, lockerS, groups, lockers, groupedLockers } = this.state;

        let layout = (circular) ?
            <div className={classes.root}>
                <CircularProgress />
            </div> :
            this.state.data.length === 0 ?
                <div>
                    <span className={classes.semDados}>Sem dados disponíveis</span>
                </div> :
                <div>
                    <h5>TAXA DE PERMANÊNCIA</h5>
                    <div className="perm-top-group">
                        <MuiPickersUtilsProvider utils={MomentUtils} locale={pt}>
                            <Grid container justify="space-around">
                                <KeyboardDatePicker
                                    locale="pt"
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    label="Data Inicial"
                                    value={selectedDateInital}
                                    onChange={this.handleDateChangeInit}
                                />
                            </Grid>
                        </MuiPickersUtilsProvider>
                        <MuiPickersUtilsProvider utils={MomentUtils} locale={pt}>
                            <Grid container justify="space-around">
                                <KeyboardDatePicker
                                    locale="pt"
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    label="Data Final"
                                    value={selectedDateFinal}
                                    onChange={this.handleDateChangeFinal}
                                />
                            </Grid>
                        </MuiPickersUtilsProvider>
                        <Button onClick={this.handleSearch} color="primary">
                            Pesquisar
                        </Button>
                        <Button onClick={this.handleExport} color="default">
                            Exportar
                         </Button>
                        <TextField
                            className={classes.green}
                            id="outlined-size-input"
                            select
                            label="Locker"
                            value={lockerS}
                            onChange={this.handleChangeLocker}
                        >
                            {lockers.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            className={classes.green}
                            id="outlined-size-input"
                            select
                            label="Grupo"
                            value={group}
                            onChange={this.handleChangeGroup}
                        >
                            {groups.map((option) => (
                                <Tooltip title={groupedLockers[option.value]} key={option.value} value={option.value}>
                                    <MenuItem className='item-group' key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                </Tooltip>
                            ))}
                        </TextField>
                    </div>
                    <div className="occupancy-down">
                        <Table
                            tableHeaderColor="primary"
                            tableHead={["Permanência (horas)", "Taxa de permanência"]}
                            tableData={data}

                        />
                        <div className="char-area">
                            <Chart info={chartData} />
                        </div>
                    </div>
                </div>;

        return (
            <div>
                {layout}
            </div>
        );
    }
}
export default withStyles(useStyles)(PermanencyRateGroup);
